import { render, staticRenderFns } from "./ShapeEditingModal2.vue?vue&type=template&id=79c33336&scoped=true&"
import script from "./ShapeEditingModal2.vue?vue&type=script&lang=ts&"
export * from "./ShapeEditingModal2.vue?vue&type=script&lang=ts&"
import style0 from "./ShapeEditingModal2.vue?vue&type=style&index=0&id=79c33336&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c33336",
  null
  
)

export default component.exports